/* Think Smiths PDP story sections: details tabs + customer reels. */
(function () {
  if (window.__csTs) return;
  window.__csTs = true;

  // Tabs
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cs-ts-seg button');
    if (!b) return;
    var root = b.closest('.cs-ts-det');
    root.querySelectorAll('.cs-ts-seg button').forEach(function (x) {
      x.setAttribute('aria-selected', x === b ? 'true' : 'false');
    });
    root.querySelectorAll('.cs-ts-pane').forEach(function (p) {
      p.hidden = p.id !== b.getAttribute('aria-controls');
    });
  });

  // Reels: no video source until the card is on screen; play muted while visible.
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(v) {
    if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; }
  }
  function play(v) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function init(scope) {
    var reels = scope.querySelectorAll('.cs-ts-reel');
    if (!reels.length) return;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (!v) return;
          if (en.isIntersecting) play(v); else v.pause();
        });
      }, { threshold: 0.6 });
      reels.forEach(function (r) { io.observe(r); });
    }
    reels.forEach(function (r) {
      r.addEventListener('click', function () {
        var v = r.querySelector('video');
        if (!v) return;
        reels.forEach(function (o) {
          var ov = o.querySelector('video');
          if (o !== r && ov) { ov.muted = true; o.classList.remove('is-unmuted'); }
        });
        v.muted = !v.muted;
        r.classList.toggle('is-unmuted', !v.muted);
        play(v);
      });
    });
  }

  function boot() { document.querySelectorAll('.cs-ts-reelsec').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Tour hotspots: tap a dot, its one-line bubble opens pointing at it (one at a
  // time). Above the dot unless that would leave the image, then below; always
  // kept inside the image, with the arrow still aimed at the dot.
  function tipClose(media) {
    var dot = media.querySelector('.cs-ts-dot[aria-expanded="true"]');
    if (!dot) return null;
    dot.setAttribute('aria-expanded', 'false');
    var tip = document.getElementById(dot.getAttribute('aria-controls'));
    if (tip) { tip.classList.remove('is-on'); tip.hidden = true; }
    return dot;
  }
  function tipPlace(media, dot, tip) {
    var mr = media.getBoundingClientRect(), dr = dot.getBoundingClientRect();
    var x = dr.left + dr.width / 2 - mr.left, y = dr.top + dr.height / 2 - mr.top;
    var w = tip.offsetWidth, h = tip.offsetHeight, pad = 8, gap = 18;
    var left = Math.max(pad, Math.min(x - w / 2, mr.width - w - pad));
    var above = y - gap - h >= pad;
    tip.style.left = left + 'px';
    tip.style.top = (above ? y - gap - h : y + gap) + 'px';
    tip.style.setProperty('--ax', Math.max(12, Math.min(x - left, w - 12)) + 'px');
    tip.classList.toggle('is-below', !above);
  }
  function tipCloseAll() { document.querySelectorAll('.cs-ts-tour__media').forEach(tipClose); }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.cs-ts-dot');
    if (!dot) { tipCloseAll(); return; }
    var media = dot.closest('.cs-ts-tour__media');
    var wasOpen = dot.getAttribute('aria-expanded') === 'true';
    tipClose(media);
    if (wasOpen) return;
    var tip = document.getElementById(dot.getAttribute('aria-controls'));
    if (!tip) return;
    dot.setAttribute('aria-expanded', 'true');
    tip.hidden = false;
    tipPlace(media, dot, tip);
    requestAnimationFrame(function () { tip.classList.add('is-on'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.cs-ts-tour__media').forEach(function (m) { var d = tipClose(m); if (d) d.focus(); });
  });
  // Close on a real width change only (phones fire resize while scrolling).
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastW) { lastW = window.innerWidth; tipCloseAll(); }
  });
})();
